module.exports = __webpack_public_path__ + "static/media/recapp-logo.6adc4461.png";